import { ArrowLeftOutlined } from '@ant-design/icons';
import { Button, Typography } from 'antd';
import React from 'react';
import { useNavigate } from 'react-router';

const { Text } = Typography;

const BackButton = () => {
  const navigate = useNavigate();

  return (
    <Button
      type='text'
      onClick={() => navigate(-1)}
      style={{padding: 0}}
      icon={<ArrowLeftOutlined />}
    >
        <Text strong>Back</Text>
    </Button>
  )
}

export default BackButton;
